"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityClasses = void 0;
/**
 * CSS Class names for Entity
 */
var EntityClasses;
(function (EntityClasses) {
    /**
     * Class name to specify this is an entity
     */
    EntityClasses["ENTITY_INFO_NAME"] = "_Entity";
    /**
     * Class name to specify the type of an entity
     */
    EntityClasses["ENTITY_TYPE_PREFIX"] = "_EType_";
    /**
     * Class name to specify the ID of an entity
     */
    EntityClasses["ENTITY_ID_PREFIX"] = "_EId_";
    /**
     * Class name to specify if the entity is readonly
     */
    EntityClasses["ENTITY_READONLY_PREFIX"] = "_EReadonly_";
})(EntityClasses = exports.EntityClasses || (exports.EntityClasses = {}));
//# sourceMappingURL=EntityClasses.js.map